module.exports = __webpack_public_path__ + "static/media/user-md-chat.b4cfeb8e.svg";